import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { map } from 'rxjs';

import { MpsUserService } from '../../mps/services/mps-user.service';
import { applicationRouteNames } from '../application-route-names';
import { MpsUser } from '../models/mps-user.model';
import { ManagerEoService } from '../services/administration/manager-eo.service';

export const AdminOrManagerEoGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const managerEoService = inject(ManagerEoService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return router.createUrlTree(['/' + applicationRouteNames.dashboard]);
  }

  const user = new MpsUser(loggedInUser);

  if (user.isAdmin()) {
    return true;
  }

  // For non-admin users, check Manager EO status asynchronously to avoid
  // racing against the initial HTTP call for is-manager-eo.
  return managerEoService
    .checkIsManagerEo()
    .pipe(map((isManagerEo) => (isManagerEo ? true : router.createUrlTree(['/' + applicationRouteNames.dashboard]))));
};
